import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="page-wrapper color-scheme color-scheme--scheme-1">
      <Header />

      <main className="main-content">
        {/* Section 1: Video */}
        <section className="hero-section">
          <video autoPlay muted loop playsInline className="background-media">
            <source src="/main/main1.mp4" type="video/mp4" />
          </video>
          <div className="overlay-content">
            <h2 className="title-large">CRAFT YOUR OWN STORY</h2>
            <h3 className="subtitle">
              FEATURING <strong>HAILEY BIEBER</strong>
            </h3>
            <Link to="/shop" className="btn-discover">
              DISCOVER MORE
            </Link>
          </div>
        </section>

        {/* Section 2: Image */}
        <section className="hero-section">
          <img
            src="/main/main2.png"
            alt="New Now"
            className="background-media"
          />
          <div className="overlay-content">
            <h2 className="title-large">NEW NOW</h2>
            <Link to="/shop" className="btn-discover">
              DISCOVER MORE
            </Link>
          </div>
        </section>

        {/* Section 3: 2x2 Grid */}
        <section className="grid-section">
          <div className="grid-item">
            <img
              src="/main/main3-1.avif"
              alt="Dresses"
              className="background-media"
            />
            <div className="item-content">
              <span className="item-title">DRESSES</span>
              <Link to="/shop" className="btn-see-all">
                SEE ALL
              </Link>
            </div>
          </div>
          <div className="grid-item">
            <img
              src="/main/main3-2.avif"
              alt="Tops"
              className="background-media"
            />
            <div className="item-content">
              <span className="item-title">TOPS</span>
              <Link to="/shop" className="btn-see-all">
                SEE ALL
              </Link>
            </div>
          </div>
          <div className="grid-item">
            <img
              src="/main/main3-3.avif"
              alt="Jeans"
              className="background-media"
            />
            <div className="item-content">
              <span className="item-title">JEANS</span>
              <Link to="/shop" className="btn-see-all">
                SEE ALL
              </Link>
            </div>
          </div>
          <div className="grid-item">
            <img
              src="/main/main3-4.avif"
              alt="Bags"
              className="background-media"
            />
            <div className="item-content">
              <span className="item-title">BAGS</span>
              <Link to="/shop" className="btn-see-all">
                SEE ALL
              </Link>
            </div>
          </div>
        </section>

        {/* Section 4: Image */}
        <section className="hero-section">
          <img
            src="/main/main4.avif"
            alt="Total White"
            className="background-media"
          />
          <div className="overlay-content">
            <h2 className="title-large">TOTAL WHITE</h2>
            <Link to="/shop" className="btn-discover">
              DISCOVER MORE
            </Link>
          </div>
        </section>

        <section className="hero-section">
          <img
            src="/main/main5.avif"
            alt="Total White"
            className="background-media"
          />
          <div className="overlay-content">
            <h2 className="title-large">PARTY AND EVENTS</h2>
            <Link to="/shop" className="btn-discover">
              DISCOVER MORE
            </Link>
          </div>
        </section>
        <section className="hero-section">
          <img
            src="/main/main6.avif"
            alt="Total White"
            className="background-media"
          />
          <div className="overlay-content">
            <h2 className="title-large">BEST SELLERS</h2>
            <Link to="/shop" className="btn-discover">
              DISCOVER MORE
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
